<div class="modal-body">
  <!-- Show message if status is FALSE -->
  @if (!status) {
    <p>{{ message }}</p>
  }

  <!-- Show table only if status is TRUE -->
  @if (status) {
    <div class="table-responsive">
      <p class="heading bold modal_p">SOP Task Step</p>
      <table class="table table-bordered table-hover custom-table">
        <thead class="thead-light">
          <tr>
            <th class="modal_p">SOP Step</th>
            <th class="modal_p">Title</th>
            <th class="modal_p">Info</th>
            <th class="modal_p">Time</th>
            <th class="modal_p">Completed</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="text-dark modal_p">1</td>
            <td class="text-dark modal_p">{{ sopInfo.label }}</td>
            <td class="text-dark modal_p">{{ sopInfo.description }}</td>
            <td class="text-dark modal_p">
              {{ sopInfo.createdAt | date:'medium' }}
            </td>
            <td class="text-dark modal_p">No</td>
          </tr>
        </tbody>
      </table>
    </div>
  }

</div>

<div class="modal-footer">
  <button class="btn btn-primary" (click)="activeModal.close(true)">OK</button>
  @if (showCancel) {
    <button class="btn btn-secondary" (click)="activeModal.dismiss()">Cancel</button>
  }
</div>